import {Injectable} from "@angular/core";
import {SideSheetService} from "@app/presentation/services/side-sheet/side-sheet.service";
import {filter, take, tap} from "rxjs/operators";
import {NavigationEnd, Router} from "@angular/router";
import {Observable, Subject} from "rxjs";

@Injectable()
export class SideSheetRef {

    private afterClosedValueSubject = new Subject<void>();

    readonly afterClosedValue$ = this.afterClosedValueSubject.asObservable();

    constructor(
        private sideSheetService: SideSheetService,
        router: Router,
    ) {
        router.onSameUrlNavigation = 'reload'
        router.events.pipe(
            filter((event) => event instanceof NavigationEnd),
            take(1),
            tap(() => this.close()),
        ).subscribe()
    }

    close(value?: any) {
        this.afterClosedValueSubject.next(value);
        this.sideSheetService.close();
    }

    back(value?: any) {
        this.afterClosedValueSubject.next(value);
        this.sideSheetService.back();
    }

    afterClosedWithValue(): Observable<any> {
        return this.afterClosedValue$.pipe(take(1));
    }
    
}